import BpkButton, {
  BUTTON_TYPES,
  SIZE_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-button';
import {
  HOMEPAGE_HERO_REDIRECT_VARIANT_B_INTERACTION_SMART_METRIC,
  HOMEPAGE_HERO_REDIRECT_VARIANT_UNKNOWN_INTERACTION_SMART_METRIC,
} from '@skyscanner-internal/landing-pages-shared-constants/constants';

import { logExperimentSmartMetric } from '../../logMiniEvent';
import withErrorBoundary from '../ErrorBoundary';
import Icon from '../common/Icon';

import type { ButtonProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/ButtonProps';

const Button = ({
  // TODO: QUAR-1784 - remove isInExperimentVariantB & enableExperimentTracking props once homepage_hero_redirect_offsite experiment is done
  enableExperimentTracking = false,
  href,
  icon,
  isInExperimentVariantB = false,
  label,
  size,
  type,
}: ButtonProps) => {
  const IconComponent = icon ? Icon(icon, size) : null;
  const isTrailing = icon === 'arrow';

  // TODO: QUAR-1784 = remove handleClick once homepage_hero_redirect_offsite experiment is done
  const handleClick = enableExperimentTracking
    ? () => {
        const metric = isInExperimentVariantB
          ? HOMEPAGE_HERO_REDIRECT_VARIANT_B_INTERACTION_SMART_METRIC
          : HOMEPAGE_HERO_REDIRECT_VARIANT_UNKNOWN_INTERACTION_SMART_METRIC;
        logExperimentSmartMetric(metric);
      }
    : undefined;

  return (
    <BpkButton
      type={BUTTON_TYPES[type]}
      size={SIZE_TYPES[size]}
      href={href}
      implicit
      onClick={handleClick}
      leadingIcon={IconComponent && !isTrailing ? <IconComponent /> : null}
      trailingIcon={IconComponent && isTrailing ? <IconComponent /> : null}
    >
      {label}
    </BpkButton>
  );
};
const ButtonWithErrorBoundary = withErrorBoundary(Button, 'button-component');

export default ButtonWithErrorBoundary;
